import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  message?: string;
  actionLabel?: string;
  onAction?: () => void;
  isRetrying?: boolean;
}

const ErrorState: React.FC<ErrorStateProps> = ({ 
  message = "We couldn't load this section.",
  actionLabel = "Try Again",
  onAction,
  isRetrying = false
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6">
      <AlertCircle className="h-8 w-8 text-muted-foreground mb-4" />
      <p className="text-base text-foreground font-medium text-center mb-2">
        {message}
      </p>
      <p className="text-sm text-muted-foreground text-center mb-6">
        Check your connection and try again.
      </p>
      {onAction && (
        <Button 
          variant="outline" 
          onClick={onAction}
          disabled={isRetrying}
          className="border-border hover:bg-muted"
        >
          {isRetrying ? (
            <>
              <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
              Retrying...
            </>
          ) : (
            actionLabel
          )}
        </Button>
      )}
    </div>
  );
};

export default ErrorState;
